import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export interface PayloadSchemaField {
  data_type: string;
  points?: number;
  params?: unknown;
}

export interface CollectionInfo {
  points_count?: number | null;
  payload_schema?: Record<string, PayloadSchemaField>;
  [key: string]: unknown;
}

export const getCollectionInfo = async (
  collectionId: string,
): Promise<CollectionInfo | { detail: string }> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<CollectionInfo>({
    url: `/collections/${orgId}/${collectionId}/info`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to fetch collection info' };
  }

  if (response?.data !== undefined) {
    return response.data;
  }

  return {};
};
